import { defineEntity, custom } from './_helpers.js';

export default defineEntity('team', {
    'dutyProfile.created': custom({ scope: 'state' }),
    'dutyProfile.updated': custom({ scope: 'state' }),
    'dutyProfile.deleted': custom({ scope: 'state' }),
    'assignment.linked': custom({ scope: 'state' }),
    'assignment.unlinked': custom({ scope: 'state' }),
});
